const uniq = require('lodash.uniq');

import {
    SocketEventNewMessageAction,
    SurveyCompletedAction,
    NewBotMessageAction,
} from '../typedefs/actions';
import * as a from '../typedefs/actions';
import * as actionTypes from '../typedefs/actionTypes';
import { ConversationState as State } from '../typedefs/store';
import { createReducer } from './util';

const initialState: State = {
    starting: false,
    startError: false,
    active: false,
    minimized: false,
    hidden: false,
    surveyCompleted: false,
    accepted: false,
    endPending: false,
    ending: false,
    ended: false,
    userIds: [],
    typingStatus: {
        active: false,
    },
};

const handlers = {
    [actionTypes.LOCAL_SETTINGS_LOADED]: localSettingsLoaded,
    [actionTypes.BOT_CONVO_STARTING]: botConvoStarting,
    [actionTypes.CONVO_START_ERROR]: convoStartError,
    [actionTypes.BOT_CONVO_STARTED]: botConvoStarted,
    [actionTypes.CONVO_DETAILS_FETCHED]: mergeConvoDetails,
    [actionTypes.TOGGLE_MINIMIZED]: toggleMinimized,
    [actionTypes.REMOVE_CONVERSATION]: removeConversation,
    [actionTypes.SOCKET_EVENT_AGENT_ACCEPTED]: agentAccepted,
    [actionTypes.TOGGLE_REQUEST_END_CONVO]: requestEndConvo,
    [actionTypes.END_CONVO_PENDING]: endConvoPending,
    [actionTypes.END_CONVO_SUCCESS]: endConvoSuccess,
    [actionTypes.SOCKET_EVENT_BOT_CONVERSATION_ENDED]: endConvoSuccess,
    [actionTypes.SOCKET_EVENT_CLIENT_CHAT_STATUS_NOTIFICATION]: typingNotification,
    [actionTypes.CLIENT_CHAT_STATUS_NOTIFICATION]: typingNotification,
    [actionTypes.SOCKET_EVENT_NEW_MESSAGE]: newSocketMessage,
    [actionTypes.SOCKET_EVENT_NEW_BOT_MESSAGE]: newBotMessage,
    [actionTypes.NEW_BOT_MESSAGE]: newBotMessage,
    [actionTypes.SURVEY_COMPLETED]: surveyCompleted,
};

function localSettingsLoaded(state: State, action: a.LocalSettingsLoadedAction): State {
    return {
        ...state,
        minimized: !!action.payload.minimized,
    };
}

function botConvoStarting(state: State, action: a.BotConvoStartingAction): State {
    return { ...state, starting: true };
}

function convoStartError(state: State, action: a.ConvoStartErrorAction): State {
    return { ...state, starting: false, startError: true };
}

function botConvoStarted(state: State, action: a.BotConvoStartedAction): State {
    const { payload } = action;
    return {
        ...state,
        channel: payload.channel,
        starting: false,
        active: true,
    };
}

function mergeConvoDetails(state: State, action: a.ConvoDetailsFetchedAction): State {
    const { payload } = action;
    return {
        ...state,
        channel: payload.conversation.channel,
        starting: false,
        active: true,
        teamId: payload.conversation.teamId,
        accepted: payload.conversation.acceptedDate !== null,
        userIds: uniq([
            ...state.userIds,
            ...payload.conversation.involvedAgents.map(agent => agent.id),
        ]),
        typingStatus: {
            active: false,
        },
    };
}

function toggleMinimized(state: State, action: a.ToggleMinimizedAction): State {
    return { ...state, minimized: !state.minimized };
}

function removeConversation(state: State, action: a.RemoveConversationAction): State {
    if (action.payload.hide) {
        return {
            ...state,
            starting: false,
            active: false,
            minimized: false,
            hidden: false,
            startError: false,
            accepted: false,
            endPending: false,
            ending: false,
            ended: false,
            surveyCompleted: false,
            userIds: [],
            typingStatus: {
                active: false,
            },
        };
    }

    return state;
}

function agentAccepted(state: State, action: a.AgentAcceptedAction): State {
    return {
        ...state,
        accepted: true,
        userIds: uniq([...state.userIds, action.payload.userId]),
    };
}

function requestEndConvo(state: State, action: a.ToggleRequestEndConvoAction): State {
    return { ...state, endPending: !state.endPending };
}

function endConvoPending(state: State, action: a.EndConvoPendingAction): State {
    return { ...state, endPending: false, ending: true };
}

function endConvoSuccess(
    state: State,
    action:
        | a.EndConvoSuccessAction
        | a.SocketEventConvoEndedAction
        | a.SocketEventBotConvoEndedAction,
): State {
    return { ...state, active: false, ending: false, ended: true, typingStatus: { active: false } };
}

function typingNotification(state: State, action: a.TypingStatusAction): State {
    if (action.payload.fromType === 'visitor') return state;

    if (action.payload.status === 'composing') {
        return {
            ...state,
            typingStatus: { active: true, userId: action.payload.fromId },
        };
    } else if (action.payload.status === 'paused') {
        return {
            ...state,
            typingStatus: { active: false },
        };
    }

    return state;
}

function newSocketMessage(state: State, action: SocketEventNewMessageAction): State {
    if (action.payload.fromType === 'visitor') return state;

    return {
        ...state,
        typingStatus: { active: false },
    };
}

function newBotMessage(state: State, action: NewBotMessageAction): State {
    return {
        ...state,
        typingStatus: { active: false },
    };
}

function surveyCompleted(state: State, action: SurveyCompletedAction): State {
    return { ...state, surveyCompleted: true };
}

export default createReducer(initialState, handlers);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/conversation.ts